/**
 * Swaps every coordinate pair in a geometry array from [lng, lat] to
 * [lat, lng] (the order react-leaflet expects for `positions`/`center`).
 *
 * Why: the `/Mapas/Minhas-Areas` endpoint already returns [lat, lng], so
 * `MyAreas` renders correctly by passing `area.geo` straight through. The
 * other map reports return subarea geometry as [lng, lat] (GeoJSON/WKT
 * order), so they must be swapped before reaching Leaflet.
 *
 * Handles both shapes used by the API:
 *   - flat polygon:   [[lng, lat], ...]
 *   - nested ring:    [[[lng, lat], ...]]
 *   - single pair:    [lng, lat]   (e.g. a center point)
 */
export default function swapCoords(coords) {
  if (!Array.isArray(coords) || coords.length === 0) {
    return coords;
  }

  // Leaf pair [number, number] -> [lat, lng]
  if (
    coords.length === 2 &&
    typeof coords[0] === 'number' &&
    typeof coords[1] === 'number'
  ) {
    return [coords[1], coords[0]];
  }

  // Otherwise recurse into the nested structure
  return coords.map(swapCoords);
}
